import Svg from '../generated/Check';
import { Icon, type IconProps } from './Icon';

export const CheckIcon = (props: IconProps) => <Icon component={Svg} name="check" {...props} />;
